module.exports = __webpack_public_path__ + "static/media/2020.6.29花桥居委二居委共建.b3a3264e.jpg";